import React from 'react';
import {
  ArrowUp,
  ArrowUpRight,
  ArrowRight,
  ArrowDownRight,
  ArrowDown,
  ArrowDownLeft,
  ArrowLeft,
  ArrowUpLeft,
} from '@carbon/icons-react';
import { useGetWeatherQuery } from '@slope/graphql/apollo';
import { useStore } from '@slope/store';

export type BannerProps = {
  children?: React.ReactNode;
};

const windDirectionIconMap: React.FC<{ size?: number }>[] = [
  ArrowUp,
  ArrowUpRight,
  ArrowRight,
  ArrowDownRight,
  ArrowDown,
  ArrowDownLeft,
  ArrowLeft,
  ArrowUpLeft,
];

export const useWeather = () => {
  const origin = useStore(({ origin }) => origin);
  const { data } = useGetWeatherQuery({
    fetchPolicy: 'cache-first',
    pollInterval: 1 * 60 * 1000,
    variables: {
      latitude: origin.lat,
      longitude: origin.lng,
    },
  });

  const windDirectionIconLength = windDirectionIconMap.length;
  const windDirectionIconIndex = Math.floor(
    (((data?.weather.wind?.directionDegrees ?? 0) / 360) * windDirectionIconLength) %
      windDirectionIconLength,
  );
  const WindDirectionIcon = windDirectionIconMap[windDirectionIconIndex];

  return {
    temperatureMin: data?.weather.temperatureRange?.minCelsius ?? 0,
    temperatureMax: data?.weather.temperatureRange?.maxCelsius ?? 0,
    windSpeedMs: data?.weather.wind?.speedKph ?? 0,
    windDirection: data?.weather.wind?.directionDegrees ?? 0,
    WindDirectionIcon,
  };
};
